<template>
  <!--
    เครื่องนี้ถือ OPEN ของรอบการขายที่ปิดไปแล้ว (เช่น notebook พับจอข้ามคืน)
    ต้องอยู่เหนือ ModalEmployeePin (z-10) เพราะเครื่องที่ตื่นจาก sleep มักอยู่หน้าล็อก PIN
    ไม่มีปุ่มปิด โหลดใหม่ได้อย่างเดียว — ข้อมูลจริงอยู่บน cloud การโหลดใหม่ไม่ทำให้อะไรหาย
  -->
  <div
    v-if="jobsStore.isSessionStale"
    class="fixed inset-0 z-[70] flex items-center justify-center bg-gray-500 bg-opacity-75 p-4"
  >
    <div class="w-full max-w-md rounded-lg bg-white p-6 text-left shadow-xl">
      <h1 class="mb-3 text-2xl font-bold text-red-500">
        {{ $t("pos.main.session_stale.label.title") }}
      </h1>
      <p class="text-lg text-gray-700">
        {{ $t("pos.main.session_stale.label.mine", { openedAt: labels.mine }) }}
      </p>
      <p v-if="labels.current" class="mt-1 text-lg text-gray-700">
        {{ $t("pos.main.session_stale.label.current", { openedAt: labels.current }) }}
      </p>
      <p class="mt-4 text-sm text-red-500">
        {{ $t("pos.main.session_stale.label.reload_before_pay") }}
      </p>
      <button
        type="button"
        class="mt-6 inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-3 text-base font-semibold text-white shadow-sm hover:bg-indigo-500"
        @click="reload"
      >
        {{ $t("pos.main.session_stale.btn.reload") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as Sentry from "@sentry/vue";

const jobsStore = useJobsStore();
const { openedAtLabels, reload } = useSessionStale();

const labels = computed(() => openedAtLabels());

// เก็บไว้ดูย้อนหลังว่าเกิดกับร้านไหน / เครื่องแบบไหน บ่อยแค่ไหน
watch(
  () => jobsStore.isSessionStale,
  (stale) => {
    if (!stale) return;
    try {
      Sentry.captureMessage("[businessSession] stale session blocked", {
        level: "warning",
        extra: {
          storeId: useStoreId(),
          runMode: useRunningMode().getMode(),
          openShop: {
            jobId: jobsStore.openShop?.jobId,
            businessDate: jobsStore.openShop?.businessDate,
            timestamp: jobsStore.openShop?.timestamp,
          },
          businessSession: jobsStore.businessSession,
        },
      });
    } catch {
      // Sentry ไม่ได้ init (dev / localhost)
    }
  },
  { immediate: true }
);
</script>
